module.exports = function() {
  return new Worker(__webpack_public_path__ + "85ba6845ea54952633a4.worker.js");
};